
export { Input } from "/www/app/apps/core/src/components/index.ts"
export { Text } from "/www/app/apps/core/src/components/index.ts"